import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import AddTeachersToClassForm from "../../components/Forms/AddTeachersToClassForm";

class AddTeachersToClass extends Component {
  render() {
    return (
      <Modal size="lg" isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader>Lägg till lärare i klassen</ModalHeader>
        <ModalBody>
          <AddTeachersToClassForm
            loadTeachers={this.props.loadTeachers}
            classId={this.props.classId}
            dismissModal={this.props.toggle}
            teachers={this.props.teachers}
            existingTeachers={this.props.existingTeachers}
            reloadAllTeachers={this.props.reloadAllTeachers}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default AddTeachersToClass;
